






















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Search, List, Sticky, Icon } from 'vant';
import { init } from './api/index';
import { namespace, State } from 'vuex-class';
import * as mutationTypes from './store/mutation-types';
import { appShare, wxShareInfo } from '@/common/ts/common';

const Modules = namespace('CDWM20200317');
Vue.use(Search)
  .use(List)
  .use(Sticky)
  .use(Icon);
@Component({
  components: {},
})
export default class SearchSchoolList extends Vue {
  public value: string = '';
  public type: any;
  public recordList: any[] = [];
  public schoolList: any[] = [];
  public schools: any[] = [];
  public ifDoSearch: boolean = true;
  public loading: boolean = false;
  public loadingStatus: boolean = false;
  public valueText: string = '';
  public finished: boolean = false;
  public page = 1;
  public showHistory: boolean = true;
  public failShow: boolean = false;
  public showList: boolean = false;

  @Modules.Mutation(mutationTypes.SAVE_SCHOOL_DATA) saveSchoolData!: (
    schooldata: any,
  ) => void;
  @Watch('value')
  public onKeywordChange(newval: string, val: string) {
    if (!newval) {
      this.reset();
      console.log('监听value');
    }
  }
  @Watch('$route')
  public onRouteChange() {
    this.reset();
    this.init();
    // console.log('SearchPage路径改变');
  }
  public reset() {
    this.value = '';
    this.failShow = false;
    this.showHistory = true;
    this.showList = false;
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.schoolList = [];
  }
  public created() {
    this.init();
    // 分享
    appShare({
      title: '吃得文明公益主题征文大赛',
      url: window.location.href,
      subtitle:
        '文明健康、绿色环保的生活方式让我们远离病毒，与自然和谐相处，关系大家一生的幸福。',
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '吃得文明公益主题征文大赛',
      subtitle:
        '文明健康、绿色环保的生活方式让我们远离病毒，与自然和谐相处，关系大家一生的幸福。',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  public init() {
    init().then((res) => this.getInitData(res));
    // 搜索记录
    if (localStorage.getItem('CDWMSchoolList')) {
      this.recordList = JSON.parse(
        localStorage.getItem('CDWMSchoolList') || '[]',
      );
    } else {
      localStorage.setItem('CDWMSchoolList', JSON.stringify([]));
    }
  }
  public getInitData(res: any) {
    // this.school = res.data.school
    this.schools = res.data.school.map((item: any) => {
      return {
        exactName: item,
      };
    });
  }
  public onLoad() {
    if (this.loadingStatus === false) {
      // 解决下拉加载两次page为1的问题
      this.loadingStatus = true;
      // 区别onSearch和下拉方法
      this.ifDoSearch = false;
      setTimeout(() => {
        this.onSearch(this.valueText);
      }, 200);
    }
  }
  public onSearch(e: any, exact: boolean = false) {
    if (e) {
      this.showHistory = false;
      this.showList = true;
      this.failShow = false;
      this.loading = true;
      this.finished = false;
      this.loadingStatus = true;
      // value为输入框数据；valueText为搜索数据
      this.valueText = e;
      if (this.ifDoSearch === true) {
        this.page = 1;
        this.schoolList = [];
      }
      // 设置搜索历史
      this.setLocalHistory();
      // 获取作文列表搜索结果
      // schoolSearch({ search: this.valueText, page: this.page }).then(
      //   (res: any) => {
      //     // 搜索失败
      //     if (this.page === 1 && res.data.length <= 0) {
      //       this.failShow = true;
      //       this.showList = false;
      //     }
      //     if (res.data && res.data.length === 0) {
      //       this.finished = true;
      //     } else {
      //       // 注：undefined和null无法转成对象
      //       const searchListArr = Object.values(res.data);
      //       this.schoolList = [...this.schoolList, ...searchListArr];
      //       this.page = this.page + 1;
      //     }
      //     this.loading = false;
      //     this.loadingStatus = false;
      //     this.ifDoSearch = true;
      //   },
      // );
      if (!e) {
        return console.log('no keyword, and reject');
      }
      // emit some val
      console.log('emit your val');
      // this.$emit('input', this.keyword);
      this.schoolList = [];
      console.log('用户输入关键词:', e);
      for (const schoolItem of this.schools) {
        if (exact) {
          // 精确匹配
          if (schoolItem.exactName.indexOf(e) !== -1) {
            console.log('精确匹配到搜索结果:', schoolItem.exactName);
            this.schoolList.push(schoolItem.exactName);
          }
        } else {
          // 模糊匹配
          const reg = new RegExp(['', ...e, ''].join('.*'));
          if (reg.test(schoolItem.exactName)) {
            console.log('模糊匹配到搜索结果:', schoolItem.exactName);
            this.schoolList.push(schoolItem.exactName);
          }
        }
      }
      if (this.schoolList.length === 0) {
        console.log('未找到搜索内容');
        this.failShow = true;
        this.showList = false;
      }
    }
  }
  public chooseSchool(item: any, index: any) {
    this.saveSchoolData({
      text: item,
      value: index,
    });
    this.$router.go(-1);
  }
  public onRecordSearch(index: any) {
    // 重置上一次搜索数据
    this.reset();
    // 设置当前关键词
    this.value = this.recordList[index];
    this.onSearch(this.recordList[index]);
    this.recordList.splice(this.recordList.indexOf(this.value), 1);
    this.recordList.unshift(this.value);
    window.localStorage.setItem(
      'CDWMSchoolList',
      JSON.stringify(this.recordList),
    );
  }
  public setLocalHistory() {
    // 存入搜索记录
    let localHistory = JSON.parse(
      localStorage.getItem('CDWMSchoolList') || '[]',
    );
    if (this.value !== '') {
      localHistory.unshift(this.value);
    }
    // 数组去重
    const uniqueArr = new Set(localHistory);
    // 将其他对象转换成数组
    localHistory = Array.from(uniqueArr).slice(0, 10);
    localStorage.setItem('CDWMSchoolList', JSON.stringify(localHistory));
    this.recordList = localHistory;
  }
  // 清除全部搜索记录
  public deleteList() {
    localStorage.removeItem('CDWMSchoolList');
    this.recordList = [];
  }
  // 清除某个搜索记录
  public deleteListItem(index: any) {
    this.recordList.splice(index);
    const deleteItemList = JSON.parse(
      localStorage.getItem('CDWMSchoolList') || '[]',
    );
    deleteItemList.splice(index, 1);
    localStorage.setItem('CDWMSchoolList', JSON.stringify(deleteItemList));
    this.recordList = deleteItemList;
  }
  // 取消搜索
  public cancelSearch() {
    this.$router.go(-1);
    this.reset();
  }
}
